import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./layout.css";
import Header from "./Header";

import {
  LuChevronUp,
  LuChevronDown,
  LuCornerDownRight,
  LuChevronRight,
  LuChevronLeft,
  LuBriefcase,
  LuTicket,
  LuDatabase,
} from "react-icons/lu";

import {
  MdDashboard,
  MdOutlineAccessTime,
  MdSettingsSuggest,
  MdOutlineEngineering,
} from "react-icons/md";

import {
  FaUsers,
  FaCalendarAlt,
  FaTag,
  FaHourglassHalf,
  FaCogs,
  FaTags,
  FaCar,
  FaLayerGroup,
  FaListAlt,
  FaCarSide,
  FaBan,
  FaUserCheck,
  FaMoneyBillWave,
  FaPercent,
  FaBusinessTime,
  FaTicketAlt,
  FaMapMarkerAlt,
  FaPlusSquare,
  FaListUl,
  FaInfoCircle,
  FaShieldAlt,
  FaFileInvoiceDollar,
  FaCog,
  FaImage,
  FaCalendarCheck,
  FaFileExcel,
  FaTrashAlt,
  FaEdit,
  FaCopy,
  FaAddressBook,
  FaChartLine,
  FaQuestionCircle,
  FaFileAlt,
  FaLanguage,
  FaGlobe,
  FaInfo,
  FaAlignLeft,
  FaSyncAlt,
  FaEnvelope,
  FaKey,
} from "react-icons/fa";

/* =========================================================
   NAVIGATION
========================================================= */

const NAV = [
  {
    icon: <MdDashboard />,
    label: "Dashboard",
    path: "/dashboard",
  },

  {
    icon: <FaUsers />,
    label: "User Management",
    path: "/user-management",
  },

  {
    icon: <LuBriefcase />,
    label:"Rent Management",
    children: [
      {
        icon: <MdOutlineAccessTime />,
        label: "Rental Slab",
        path: "/rent-durations",
      },

      {
        icon: <FaCalendarAlt />,
        label: "Season Details",
        children: [
          {
            icon: <FaTag />,
            label: "Season Name",
            path: "/season-name",
          },

          {
            icon: <FaHourglassHalf />,
            label: "Season Duration",
            path: "/season-duration",
          },
        ],
      },

      {
        icon: <FaCogs />,
        label: "Master Module",
        children: [
          {
            icon: <FaTags />,
            label: "Brand Name",
            path: "/manage-brand",
          },

          {
            icon: <MdSettingsSuggest />,
            label: "Transmission",
            path: "/manage-transmission",
          },

          {
            icon: <MdOutlineEngineering />,
            label: "Engine Capacity",
            path: "/manage-engcapacity",
          },
        ],
      },

      {
        icon: <FaCar />,
        label: "Car Details",
        children: [
          {
            icon: <FaLayerGroup />,
            label: "Car Group",
            path: "/cargroup",
          },

          {
            icon: <FaListAlt />,
            label: "Car Items",
            path: "/caritems",
          },

          {
            icon: <FaCarSide />,
            label: "Car Model Details",
            path: "/manage-cars",
          },

          {
            icon: <FaBan />,
            label: "Stop Sale",
            path: "/stop-sale",
          },
        ],
      },

      {
        icon: <FaUserCheck />,
        label: "Regular Client Details",
        path: "/manage-regular-clients",
      },

      {
        icon: <FaMoneyBillWave />,
        label: "Price Details",
        path: "/car-price",
      },

      {
        icon: <FaPercent />,
        label: "Special Discount",
        path: "/special-discount",
      },

      {
        icon: <FaBusinessTime />,
        label: "Special Hour Charge",
        path: "/manage-special-hour",
      },

      {
        icon: <FaTicketAlt />,
        label: "Manage Coupon Code",
        path: "/coupon-code",
      },

      {
        icon: <FaMapMarkerAlt />,
        label: "Locations",
        path: "/manage-location",
      },

      {
        icon: <FaPlusSquare />,
        label: "Optional Extra",
        children: [
          {
            icon: <FaListUl />,
            label: (
              <>
                Optional Extra <br />
                Item Names
              </>
            ),
            path: "/manage-optionalextra",
          },

          {
            icon: <FaInfoCircle />,
            label: (
              <>
                Optional Extra <br />
                Details
              </>
            ),
            path: "/optional-extra-detail",
          },
        ],
      },

      {
        icon: <FaShieldAlt />,
        label: "Insurance Extra",
        children: [
          {
            icon: <FaListUl />,
            label: (
              <>
                Insurance Extra <br />
                Item Names
              </>
            ),
            path: "/manage-insurance",
          },

          {
            icon: <FaFileInvoiceDollar />,
            label: (
              <>
                Paid Insurance
                <br />
                Details
              </>
            ),
            path: "/insurance-detail",
          },
        ],
      },
    ],
  },

  {
    icon: <LuTicket />,
    label:"Manage Bookings",
    children: [
      {
        icon: <FaCalendarCheck />,
        label: "Manage Online Bookings",
        path: "/manage-bookings",
      },

      {
        icon: <FaFileExcel />,
        label: "Generate Excel",
        path: "/generate-manage-bookings-Excal",
      },

      {
        icon: <FaTrashAlt />,
        label: "Deleted Online Booking",
        path: "/del-online",
      },

      {
        icon: <FaEdit />,
        label: (
          <>
            Manage Modify / Cancel
            <br />
            Requests
          </>
        ),
        path: "/manage-modifyacancel-requests",
      },

      {
        icon: <FaCopy />,
        label: (
          <>
            Manage Multiple Booking
            <br />
            Details
          </>
        ),
        path: "/manage-multiple-booking-details",
      },

      {
        icon: <FaAddressBook />,
        label: "Manage Contacts",
        path: "/manage-contacts",
      },
    ],
  },

  {
    icon: <FaLanguage />,
    label: (
      <>
        Multilingual Section 
      </>
    ),
    children: [
      {
        icon: <FaGlobe />,
        label: "Language",
        path: "/manage-language",
      },

      {
        icon: <FaInfo />,
        label: (
          <>
            Information in English
          </>
        ),
        path: "/manage-infoinenglish",
      },

      {
        icon: <FaAlignLeft />,
        label: "Static Information",
        path: "/manage-static-infos",
      },

      {
        icon: <FaSyncAlt />,
        label: (
          <>
            Dynamic  Information
          </>
        ),
        path: "/manage-dynamic-infos",
      },

      {
        icon: <FaEnvelope />,
        label: "Messages",
        path: "/manage-messages-infos",
      },
    ],
  },

  {
    icon: <LuDatabase />,
    label: "CMS",
    children: [
      {
        icon: <FaImage />,
        label: "Banners",
        path: "/manage-banners",
      },

      {
        icon: <FaChartLine />,
        label: "Manage SEO",
        path: "/manage-seo",
      },

      {
        icon: <FaQuestionCircle />,
        label: "Manage FAQ",
        path: "/manage-faqs",
      },

      {
        icon: <FaFileAlt />,
        label: "Content Management",
        path: "/manage-content",
      },
    ],
  },

  
  {
    icon: <FaCog />,
    label: "Settings",
    path: "/manage-setting",
  },

  {
    icon: <FaKey />,
    label: "Change Password",
    path: "/change-password",
  },
];

/* =========================================================
   MODULE ID → ROUTE MAP
========================================================= */

const MOD_PATH_MAP = {
  3: ["/season-name", "/season-duration"],

  4: [
    "/cargroup",
    "/manage-cars",
    "/car-price",
    "/transfer-price",
    "/stop-sale",
    "/boost-price",
    "/promotional-price",
    "/weekend-rate",
  ],

  5: [
    "/manage-city",
    "/manage-location",
  ],

  6: [
    "/manage-optionalextra",
    "/optional-extra-detail",
    "/manage-insurance",
    "/insurance-detail",
  ],

  10: ["/manage-faqs"],

  11: [
    "/manage-bookings",
    "/manage-transferbooking",
  ],

  12: ["/manage-seo"],

  13: ["/rent-durations"],

  14: ["/user-management"],

  15: [
    "/cab-owner-details",
    "/driver-details",
    "/cab-details",
  ],

  16: [
    "/leasing-cars",
    "/page-content",
    "/manage-leasinginq",
  ],

  17: ["/coupon-code"],

  18: ["/manage-delaycharge"],

  19: [
    "/manage-nightdelivery",
    "/manage-pagemaster",
    "/manage-setting",
    "/manage-section",
    "/manage-booking-engine",
  ],

  20: ["/manage-banners"],

  21: ["/manage-attraction"],

  22: ["/manage-testimonial"],

  23: ["/manage-gallery"],

  24: ["/manage-content"],

  25: ["/manag-inquiry"],

  26: ["/manage-request"],

  27: ["/manage-contracts"],

  28: [
    "/manage-brand",
    "/manage-transmission",
    "/manage-engcapacity",
  ],

  29: ["/caritems"],

  30: ["/manage-regular-clients"],

  31: ["/special-discount"],

  32: ["/manage-special-hour"],

  33: ["/manage-contacts"],
};

/* =========================================================
   GET ACCESSIBLE PATHS
========================================================= */

function getAccessiblePaths(mod_ids) {
  if (
    !mod_ids ||
    !Array.isArray(mod_ids) ||
    mod_ids.length === 0
  ) {
    return new Set();
  }

  const paths = new Set();

  mod_ids.forEach((mid) => {
    const moduleId = Number(mid);

    const modulePaths =
      MOD_PATH_MAP[moduleId] || [];

    modulePaths.forEach((path) => {
      paths.add(path);
    });
  });

  return paths;
}

/* =========================================================
   FILTER NAVIGATION
========================================================= */

function filterNav(
  nav,
  accessiblePaths,
  isAdmin
) {
  if (isAdmin) return nav;

  const filterRecursive = (items) => {
    return items
      .map((item) => {
        if (item.children) {
          const filteredChildren =
            filterRecursive(
              item.children
            );

          if (
            filteredChildren.length === 0
          ) {
            return null;
          }

          return {
            ...item,
            children:
              filteredChildren,
          };
        }

        if (
          item.path === "/dashboard" ||
          item.path === "/change-password"
        ) {
          return item;
        }

        return accessiblePaths.has(
          item.path
        )
          ? item
          : null;
      })
      .filter(Boolean);
  };

  return filterRecursive(nav);
}

/* =========================================================
   GET ITEM KEY
========================================================= */

// const getItemKey = (item, path = "") => {
//   if (typeof item.label === "string") {
//     return `${path}-${item.label}`;
//   }

//   /*
//    * React elements do not give us a stable string.
//    * The parent path is enough for our menu structure.
//    */
//   return `${path}-menu`;
// };

/* =========================================================
   LAYOUT
========================================================= */

export default function Layout({
  children,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const [sideOpen, setSideOpen] =
    useState(true);

  const [openMenus, setOpenMenus] =
    useState({});

  const [user, setUser] =
    useState(null);

  const navRef = useRef(null);

  const isRestoringRef =
    useRef(false);

  /* =========================================================
     LOAD USER
  ========================================================= */

  useEffect(() => {
    try {
      const storedUser =
        localStorage.getItem("user");

      if (storedUser) {
        setUser(
          JSON.parse(storedUser)
        );
      }
    } catch (error) {
      console.error(
        "Unable to load user:",
        error
      );

      setUser(null);
    }
  }, []);

  /* =========================================================
     RESTORE SIDEBAR SCROLL
  ========================================================= */

  useEffect(() => {
    const nav = navRef.current;

    if (!nav) return;

    const saved =
      sessionStorage.getItem(
        "sidebarScrollTop"
      );

    if (!saved) return;

    const scrollPosition =
      parseInt(saved, 10);

    if (
      Number.isNaN(scrollPosition)
    ) {
      return;
    }

    isRestoringRef.current = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (navRef.current) {
          navRef.current.scrollTop =
            scrollPosition;
        }

        setTimeout(() => {
          isRestoringRef.current =
            false;
        }, 150);
      });
    });
  }, [location.pathname]);

  /* =========================================================
     SAVE SIDEBAR SCROLL
  ========================================================= */

  useEffect(() => {
    const nav = navRef.current;

    if (!nav) return;

    const handleScroll = () => {
      if (
        isRestoringRef.current
      ) {
        return;
      }

      sessionStorage.setItem(
        "sidebarScrollTop",
        String(nav.scrollTop)
      );
    };

    nav.addEventListener(
      "scroll",
      handleScroll
    );

    return () => {
      nav.removeEventListener(
        "scroll",
        handleScroll
      );
    };
  }, []);

  /* =========================================================
     FIND ACTIVE PATH
  ========================================================= */

  const hasActiveChild = (
    item
  ) => {
    if (
      item.path ===
      location.pathname
    ) {
      return true;
    }

    if (item.children) {
      return item.children.some(
        (child) =>
          hasActiveChild(child)
      );
    }

    return false;
  };

  /* =========================================================
     AUTO OPEN ACTIVE MENUS
     
     IMPORTANT:
     Only open the menu hierarchy
     required for the current page.
     
     It will NOT automatically open
     Business + Booking + CMS together.
  ========================================================= */

  useEffect(() => {
    const activeKeys = {};

    const findActivePath = (
      items,
      parentKey = "root"
    ) => {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];

        const itemKey = `${parentKey}-${i}`;

        if (
          item.children &&
          item.children.length
        ) {
          if (
            hasActiveChild(item)
          ) {
            activeKeys[itemKey] =
              true;

            findActivePath(
              item.children,
              itemKey
            );

            return true;
          }
        }

        if (
          item.path ===
          location.pathname
        ) {
          return true;
        }
      }

      return false;
    };

    findActivePath(NAV);

    setOpenMenus(activeKeys);

    // eslint-disable-next-line
  }, [location.pathname]);

  /* =========================================================
     LOGOUT
  ========================================================= */

  const logout = () => {
    localStorage.clear();

    sessionStorage.removeItem(
      "sidebarScrollTop"
    );

    navigate("/login");
  };

  /* =========================================================
     USER ACCESS
  ========================================================= */

  const isAdmin =
    Number(user?.user_type) === 1;

  const accessiblePaths =
    getAccessiblePaths(
      user?.mod_ids
    );

  const filteredNav =
    filterNav(
      NAV,
      accessiblePaths,
      isAdmin
    );

  /* =========================================================
     TOGGLE MENU
     
     This is the important part.
     
     Same level:
       Open one
       Close all other menus

     Different level:
       Parent remains open
       Only sibling nested menu closes
  ========================================================= */

  const toggleMenu = (
    itemKey,
    level,
    parentKey
  ) => {
    setOpenMenus((prev) => {
      const currentlyOpen =
        Boolean(prev[itemKey]);

      const next = {
        ...prev,
      };

      /*
       * CLOSE CURRENT MENU
       */
      if (currentlyOpen) {
        next[itemKey] = false;

        /*
         * Also close all children
         * belonging to this menu.
         */
        Object.keys(next).forEach(
          (key) => {
            if (
              key.startsWith(
                `${itemKey}-`
              )
            ) {
              next[key] = false;
            }
          }
        );

        return next;
      }

      /*
       * OPEN CURRENT MENU
       */
      next[itemKey] = true;

      /*
       * Close ONLY siblings
       * at the SAME level.
       *
       * This is what gives:
       *
       * Business Configuration
       *      ↓
       * Season Details
       *
       * then
       *
       * Master Module
       *      ↓
       * Season closes
       *
       * while Business remains open.
       */

      Object.keys(next).forEach(
        (key) => {
          const sameParent =
            key.startsWith(
              `${parentKey}-`
            );

          const isDirectSibling =
            sameParent &&
            key.split("-").length ===
              itemKey
                .split("-")
                .length;

          if (
            isDirectSibling &&
            key !== itemKey
          ) {
            next[key] = false;

            /*
             * Close nested children
             * of the closed sibling.
             */
            Object.keys(next).forEach(
              (childKey) => {
                if (
                  childKey.startsWith(
                    `${key}-`
                  )
                ) {
                  next[childKey] =
                    false;
                }
              }
            );
          }
        }
      );

      /*
       * SPECIAL TOP-LEVEL ACCORDION
       *
       * If level === 0:
       *
       * Business Configuration
       * Booking Management
       * CMS
       *
       * only ONE can be open.
       */
      if (level === 0) {
        Object.keys(next).forEach(
          (key) => {
            if (
              key.startsWith(
                "root-"
              ) &&
              key.split("-").length ===
                2 &&
              key !== itemKey
            ) {
              next[key] = false;

              /*
               * Close all nested menus
               * under the closed top menu.
               */
              Object.keys(next).forEach(
                (childKey) => {
                  if (
                    childKey.startsWith(
                      `${key}-`
                    )
                  ) {
                    next[childKey] =
                      false;
                  }
                }
              );
            }
          }
        );
      }

      return next;
    });
  };

  /* =========================================================
     NAVIGATION
  ========================================================= */

  const handleNavigation = (
    path
  ) => {
    if (path) {
      navigate(path);
    }
  };

  /* =========================================================
     RENDER NAVIGATION
  ========================================================= */

  const renderNavItems = (
    items,
    level = 0,
    parentKey = "root"
  ) => {
    return items.map(
      (item, index) => {
        const hasChildren =
          Boolean(
            item.children &&
              item.children.length > 0
          );

        /*
         * IMPORTANT:
         *
         * Key is based on position,
         * not React label.
         *
         * This allows nested menus
         * to have independent state.
         */
        const itemKey =
          `${parentKey}-${index}`;

        const isActive =
          location.pathname ===
            item.path ||
          (hasChildren &&
            hasActiveChild(item));

        const isMenuOpen =
          Boolean(
            openMenus[itemKey]
          );

        /*
         * Nested indentation
         */
        const paddingLeftStyle =
          level > 1
            ? {
                paddingLeft: `${
                  level * 1.2
                }rem`,
              }
            : {};

        return (
          <div
            key={itemKey}
            className={
              level === 0
                ? "navGroup"
                : ""
            }
          >
            {/* =================================================
                MENU ITEM
            ================================================= */}

            <div
              className={`
                ${
                  level === 0
                    ? "navItem"
                    : "subItem"
                }
                ${
                  isActive
                    ? level === 0
                      ? "navActive"
                      : "subActive"
                    : ""
                }
              `}
              style={{
                ...paddingLeftStyle,

                display: "flex",

                alignItems:
                  "center",

                cursor:
                  "pointer",

                padding:
                  level === 0
                    ? "10px 16px"
                    : "8px 12px",

                /*
                 * Keep your existing
                 * level 2 background.
                 */
                backgroundColor:
                  level === 2
                    ? "#2d7e7c"
                    : undefined,
              }}
              onClick={(e) => {
                e.stopPropagation();

                if (hasChildren) {
                  toggleMenu(
                    itemKey,
                    level,
                    parentKey
                  );
                } else {
                  handleNavigation(
                    item.path
                  );
                }
              }}
            >
              {/* =================================================
                  ICON
              ================================================= */}

              <span
                className={
                  level === 0
                    ? "navIcon"
                    : "subIcon"
                }
                style={{
                  display: "flex",

                  alignItems:
                    "center",

                  marginRight:
                    "12px",
                }}
              >
                {item.icon}
              </span>

              {/* =================================================
                  LABEL
              ================================================= */}

              {sideOpen && (
                <>
                  <span
                    className={
                      level === 0
                        ? "navLabel"
                        : "subLabel"
                    }
                    style={{
                      flexGrow: 1,

                      whiteSpace:
                        "nowrap",
                    }}
                  >
                    {item.label}
                  </span>

                  {/* =================================================
                      ARROW
                  ================================================= */}

                  {hasChildren && (
                    <span
                      className="navArrow"
                      style={{
                        display:
                          "flex",

                        alignItems:
                          "center",
                      }}
                    >
                      {isMenuOpen ? (
                        <LuChevronUp />
                      ) : (
                        <LuChevronDown />
                      )}
                    </span>
                  )}
                </>
              )}
            </div>

            {/* =================================================
                NESTED SUBMENU
            ================================================= */}

            {hasChildren &&
              isMenuOpen &&
              sideOpen && (
                <div
                  className="submenu"
                  style={{
                    display:
                      "flex",

                    flexDirection:
                      "column",

                    paddingLeft:
                      "16px",

                    marginLeft:
                      "16px",

                    borderLeft:
                      "1px solid #e5e7eb",

                    marginTop:
                      "4px",

                    borderRadius:
                      "4px",
                  }}
                >
                  {renderNavItems(
                    item.children,
                    level + 1,
                    itemKey
                  )}
                </div>
              )}
          </div>
        );
      }
    );
  };

  /* =========================================================
     PAGE
  ========================================================= */

  return (
    <div className="root">
      {/* =====================================================
          SIDEBAR
      ===================================================== */}

      <aside
        className={`
          sidebar
          ${
            sideOpen
              ? "sidebarOpen"
              : "sidebarClosed"
          }
        `}
      >
        {/* ===================================================
            SIDEBAR TOP
        =================================================== */}

        <div className="sideTop">
          <div className="logoWrap">
            <div className="logoIcon">
              ✦
            </div>

            {sideOpen && (
              <span className="logoText">
                Crete Holidays
              </span>
            )}
          </div>

          <button
            type="button"
            className="collapseBtn"
            onClick={() =>
              setSideOpen(
                (prev) => !prev
              )
            }
            title={
              sideOpen
                ? "Collapse sidebar"
                : "Expand sidebar"
            }
          >
            {sideOpen ? (
              <LuChevronRight />
            ) : (
              <LuChevronLeft />
            )}
          </button>
        </div>

        {/* ===================================================
            NAVIGATION
        =================================================== */}

        <nav
          ref={navRef}
          className="nav"
        >
          {renderNavItems(
            filteredNav
          )}
        </nav>

        {/* ===================================================
            LOGOUT
        =================================================== */}

        <div className="sideBottom">
          <button
            type="button"
            className="logoutBtn"
            onClick={logout}
            title="Logout"
          >
            <span className="logoutIcon">
              <LuCornerDownRight />
            </span>

            {sideOpen && (
              <span>
                Logout
              </span>
            )}
          </button>
        </div>
      </aside>

      {/* =====================================================
          HEADER
      ===================================================== */}

      <Header />

      {/* =====================================================
          MAIN
      ===================================================== */}

      <main
        className={`
          main
          ${
            sideOpen
              ? "mainOpen"
              : "mainClosed"
          }
        `}
      >
        {children}
      </main>
    </div>
  );
}
